import { FC, ReactNode } from "react";

import styles from "./label.module.scss";

export interface LabelProps {
  children?: ReactNode;
}

export const Label: FC<LabelProps> = ({ children }) => <span className={styles.label}>{children}</span>;
